import { render, staticRenderFns } from "./DidntReturnStaffGist.vue?vue&type=template&id=63a10e10&scoped=true"
import script from "./DidntReturnStaffGist.vue?vue&type=script&lang=js"
export * from "./DidntReturnStaffGist.vue?vue&type=script&lang=js"
import style0 from "./DidntReturnStaffGist.vue?vue&type=style&index=0&id=63a10e10&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a10e10",
  null
  
)

export default component.exports